import { EXPRESS_API } from 'configs/api/expressApi';
import { errorToast } from 'lib/components/toasts/error';
import { useMutation, useQueryClient } from 'react-query';
import { successToast } from 'lib/components/toasts/success';
import { foldersKeys } from '../folders/foldersKeys';

export const removeFolderAccessSettings = async (
  folderId: number
): Promise<{ success: boolean }> => {
  const validatedFolderId = Number(folderId);
  if (!Number.isInteger(validatedFolderId) || validatedFolderId <= 0) {
    throw new Error('folderId must be a positive integer');
  }
  const safeFolderId = encodeURIComponent(validatedFolderId);
  const response = await EXPRESS_API.put(
    `/folders/${safeFolderId}/stop-sharing`
  );
  return response.data;
};

export const useRemoveFolderAccessSettings = () => {
  const queryClient = useQueryClient();

  return useMutation(
    (data: { folderId: number }) => removeFolderAccessSettings(data.folderId),
    {
      onError: () => {
        errorToast({
          title: 'Failed to stop sharing folder. Please try again later.',
        });
      },
      onSuccess: async () => {
        successToast({
          title: `Folder Sharing stopped successfully`,
        });
        await queryClient.invalidateQueries(foldersKeys.all());
      },
    }
  );
};
